import { SortDescriptor } from "@progress/kendo-data-query";
import { orderBy } from "@progress/kendo-react-data-tools";
import { Grid, GridCellProps, GridColumn as Column } from "@progress/kendo-react-grid"
import { useState } from "react";

const ReportsTable3 = (Props: any) => {

    const initialSort: Array<SortDescriptor> = [
        { field: "company_name", dir: "asc" },
      ];
    
      const [sort, setSort] = useState(initialSort);
    
  const netSalaryCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.total_net_salary && props.dataItem.total_net_salary}
       </td>
     )
   }
  
    return (
        <Grid
            // data={props.state.items && orderBy (props.state.items, sort, 'asc')}
            sortable={true}
            sort={sort}
            data={Props.state.items && orderBy (Props.state.items.slice(Props.state.skip, Props.state.pageSize + Props.state.skip), sort, 'asc')}
            onPageChange={Props.pageChange}
            total={Props.state.total}
            skip={Props.state.skip}
            pageable={Props.state.pageable}
            pageSize={Props.state.pageSize}
            onItemChange={Props.itemChange}
            onSortChange={(e) => {
                setSort(e.sort);
              }}
            >
            <Column field="company_name" title="Client" />
            <Column field="indivisual_contracts" title="Number of active Individual contractors" />
            <Column field="provider_resources" title="No of active provider resources"/>
            <Column field="Not integrated" title="Total number of active resources"/>
            <Column field="total_estimated_salary" title="Sum of Estimated salary"/>
            <Column field="total_net_salary" title="Sum of Net salary" cell={netSalaryCell}/>
            <Column field="total_estimated_client_bill" title="Sum of Estimated client bill"/>
            <Column field="total_actual_client_bill" title="Sum of actual client bill"/>

        </Grid>
    )
}


export default ReportsTable3